import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'isNil'
})
export class IsNilPipe implements PipeTransform {
	transform(value: any, _args?: unknown): any {
		return value === undefined || value === null;
	}
}
